<template>
  <div class="grid formgrid p-fluid">
    <div class="col-12">
        <Loader v-model="loading" />
        <Panel header="Lista de Precio">
          <div class="formgrid grid p-fluid">
          <div class="col-12">
              <FormToolbar :actions="['new','save','delete']" @new="newPriceList" @save="savePriceList" @delete="deletePriceList" />
          </div>
          <FormInputText wrapperClass="field col-12 xl:col-4" label="Clave" v-model="price_list.key_name" />
          <FormInputText wrapperClass="field col-12 xl:col-8" label="Nombre" v-model="price_list.name" />
        </div>
        </Panel>
    </div>
    <div class="col-12">
        <BasicDatatable :rows="price_lists" :selectionMode="'single'" :headers="headers" @selected="selectPriceList"/>
    </div>
  </div>
</template>
<script>
import FormToolbar from "../../../components/general/BasicFormToolbar.vue";
import FormInputText from "../../../components/general/FormInputText.vue";
import formMixin from '../../../mixins/form.js';
import { price_list } from "../../../models/price_list";
import Loader from "../../../components/general/Loader.vue";
import BasicDatatable from "../../../components/general/BasicDatatable.vue";
import { fillObject, HeaderGrid } from '../../../utilities/General';
export default {
  mixins: [formMixin],
    expose: ["refresh"],
  components: { FormInputText, FormToolbar, Loader, BasicDatatable },
  data() {
    return {
      loading: false,
      price_list: new price_list(),
      price_lists: [],
      headers: [
        new HeaderGrid("Clave", "key_name"),
        new HeaderGrid("Nombre", "name")
      ]
    };
  },
  methods: {
    async refresh() {
        this.loading = true;
        this.price_list = new price_list(this.session);
        try {
        this.price_lists = await this.price_list.all();
        } catch (error) {
          this.showError(error);
        } finally {
        this.loading = false;
        }
    },
    selectPriceList(entity) {
      this.price_list = fillObject(this.price_list, entity);
    },
    newPriceList() {
      this.price_list = new price_list(this.session);
    },
    async savePriceList() {
      this.loading = true;
      try {
        var newPriceList = await this.price_list.save();
        this.price_lists.push(newPriceList);
        this.newPriceList();
      } catch (error) {
        this.showError(error);
      } finally {
        this.loading = false;
      }
    },
  }
};
</script>

<style>
</style>

